import React, { useEffect, useState } from 'react';
import '../../css/pages-component.css';

const InfoPicture = ({ media }) => {
    const [urls, setUrls] = useState(null); // Initialize state for URLs

    useEffect(() => {
        if (media && media.length > 0) {
            const attributes = media[0].attributes; // Extract attributes from media
            setUrls(attributes); // Set the state with attributes
        }
    }, [media]);

    return (
        <div className="info-picture-container">
            {urls ? ( 
                <img
                    src={urls.url}
                    alt={urls.alternativeText || 'Descriptive image'}
                />
            ) : (
                <p>No media available</p> 
            )}
        </div>
    );
};

export default InfoPicture;
